
class DualLinkAuthKit
{
    private static _sharedInstance: DualLinkAuthKit;

    private enviroment = "eu";

    static sharedInstance(): DualLinkAuthKit {

        if (DualLinkAuthKit._sharedInstance == null) {
            DualLinkAuthKit._sharedInstance = new DualLinkAuthKit();
        }

        return DualLinkAuthKit._sharedInstance;
    }

    private constructor() {
        if (DualLinkAuthKit._sharedInstance != null) {
            throw new Error("DualLinkAuthKit: Instantiation failed: Use sharedInstance() instead of new.");
        }
    }

    //
    // Auth services
    //

    authURL:string = null;
    token:string = null;
    refreshToken:string = null;

    businesses = [];  
    
    userID:string = null;
    userEmail:string = null;
    userName:string = null;

    fetchBusiness(completion:any){
        const url = MIOURL.urlWithString(this.authURL + "/business");
        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, null, "GET");
        urlRequest.setHeaderValue("Bearer " + this.token, "Authorization");
        // urlRequest.setHeaderValue("test", "DL-ENVIRONMENT");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code, json){
            if (code == 200) {                
                this.businesses = json["data"];                
                this.businesses = _MIOPredicateFilterObjects(this.businesses, MIOPredicate.predicateWithFormat("db_version >= 59"));
                this.businesses = _MIOSortDescriptorSortObjects(this.businesses, [MIOSortDescriptor.sortDescriptorWithKey("name", true)]);
            }
            completion(this.businesses);
        });
    }  

    login(user:string, pass:string, completion:any) {

        // Reset
        this.userID = null;
        MIOUserDefaults.standardUserDefaults().removeValueForKey("LoginOK");
        MIOUserDefaults.standardUserDefaults().removeValueForKey("LastProductDetailPageIndex");
        MIOUserDefaults.standardUserDefaults().removeValueForKey("LastProductDetailSalesPageIndex");

        const url = MIOURL.urlWithString(this.authURL + "/token");
        let body = {
            "username": user,
            "password": pass,
            "grant_type": "password"
        }

        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        // urlRequest.setHeaderValue("test", "DL-ENVIRONMENT");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, json:any){
            let err = false;
            let result = false;
            if (code == 200 && json["status"].toLowerCase() == "ok") {
                // Login OK
                err = false;
                result = true;                                

                this.token = json["data"]["access_token"];
                let email = json["data"]["user"]["email"];
                this.userID = json["data"]["user"]["identifier"];
                this.userEmail = email;
                this.userName = json["data"]["user"]["name"];
                this.storeRefreshToken(json["data"]["refresh_token"]);

                MIOUserDefaults.standardUserDefaults().setValueForKey("LastLoginEmail", email);
                MIOUserDefaults.standardUserDefaults().setValueForKey("LoginToken", this.token);
                MIOUserDefaults.standardUserDefaults().setBooleanForKey("LoginOK", true);
            }
            else {
                // Error
                err = true;
                result = false;
                this.token = null;
                this.storeRefreshToken(null);
                MIOUserDefaults.standardUserDefaults().removeValueForKey("LastLoginEmail");
                MIOUserDefaults.standardUserDefaults().removeValueForKey("LoginToken");
                MIOUserDefaults.standardUserDefaults().removeValueForKey("LoginOK");
            }

            // console.log(json);
            completion(err, result);
        });
    }

    /** Session handed over by the global shell (EmbeddedSessionController): no login here. */
    adoptSession(accessToken:string, user:ShellSessionUser) {
        this.token = accessToken;
        this.userID = user != null ? user.id : null;
        this.userEmail = user != null ? user.email : null;
        this.userName = user != null ? user.name : null;
        // Renewal is the shell's job; this manager only ever holds the access token.
        this.storeRefreshToken(null);

        MIOUserDefaults.standardUserDefaults().setValueForKey("LastLoginEmail", this.userEmail);
        MIOUserDefaults.standardUserDefaults().setValueForKey("LastLoginUser", this.userEmail);
        MIOUserDefaults.standardUserDefaults().setValueForKey("LoginToken", this.token);
        MIOUserDefaults.standardUserDefaults().setBooleanForKey("LoginOK", true);
    }

    /**
     * Exchanges the refresh token for a new access token with the same scope, so a
     * business session renews as itself. The server rotates the refresh token.
     */
    refreshSession(completion:any) {
        let refresh = this.refreshToken ?? MIOUserDefaults.standardUserDefaults().valueForKey("RefreshToken");
        if (refresh == null) {
            completion(true, false);
            return;
        }

        const url = MIOURL.urlWithString(this.authURL + "/token");
        let body = {
            "grant_type": "refresh_token",
            "refresh_token": refresh
        }

        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, json:any){
            if (code == 200 && json["status"].toLowerCase() == "ok") {
                this.token = json["data"]["access_token"];
                this.storeRefreshToken(json["data"]["refresh_token"]);

                MIOUserDefaults.standardUserDefaults().setValueForKey("LoginToken", this.token);
                MIOUserDefaults.standardUserDefaults().setBooleanForKey("LoginOK", true);
                completion(false, true);
            }
            else {
                // A rejected refresh token is spent: the family was revoked or it expired.
                this.storeRefreshToken(null);
                completion(true, false);
            }
        });
    }

    private storeRefreshToken(token:string) {
        this.refreshToken = token;
        if (token != null) MIOUserDefaults.standardUserDefaults().setValueForKey("RefreshToken", token);
        else MIOUserDefaults.standardUserDefaults().removeValueForKey("RefreshToken");
    }

    loginBusiness(business:string, completion:any)     
    {
        const url = MIOURL.urlWithString(this.authURL + "/business/token");
        let body = {
            "BusinessID": business,
        }

        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        urlRequest.setHeaderValue("Bearer " + this.token, "Authorization");
        urlRequest.execute(this, function(code:number, json:any){
            let err = false;
            let result = false;
            if (code == 200 && json["status"].toLowerCase() == "ok") {
                // Login OK
                err = false;
                result = true;                                

                this.token = json["data"]["access_token"];
                // Scoped to this business, so a renewal stays on the business session.
                this.storeRefreshToken(json["data"]["refresh_token"]);

                MIOUserDefaults.standardUserDefaults().setValueForKey("LoginToken", this.token);
            }
            else {
                // Error
                err = true;
                result = false;
                this.token = null;
                this.storeRefreshToken(null);
                MIOUserDefaults.standardUserDefaults().removeValueForKey("LoginToken");
            }

            // console.log(json);
            completion(err, result);
        });

    }

    signin(name:string, email:string, password:string, confirmed:string, completion:any) {
        const url = MIOURL.urlWithString(this.authURL + "/user/create");  
        let body = {
            "name": name,
            "username": email,
            "password": password,
            "password_confirmation": confirmed
        }

        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, json:any){                  
            if (code == 200 || code == 201) {
                completion(true, null);
            }
            else {
                completion(false, new Error(json));                
            }
        });
    }

    rememberPassword(email:string, language:string, completion:any) {
        const url = MIOURL.urlWithString(this.authURL + "/user/reset-password");
        let body = {
            "Language": language,
            "Email": email
        };
        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, json:any){                  
            if (code == 200 || code == 201) {
                completion(null, null);
            }
            else {
                completion(json, new Error(json["error"]));
            }
        });
    }


    linkBusinessUser(businessID:string, name:string, email:string, completion:any){
        const url = MIOURL.urlWithString(this.authURL + "/business/" + businessID + "/add-user");
        const body = {
            // "userName": name,
            "userEmail": email
        }
        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        urlRequest.setHeaderValue("Bearer " + this.token, "Authorization");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, json:any){
            completion(code, json != null ? json["data"] : []);
        });
    }  

    unlinkBusinessUser(businessID:string, userID:string, completion:any){
        const url = MIOURL.urlWithString(this.authURL + "/business/" + businessID + "/remove-user/" + userID);
        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, null, "GET");
        urlRequest.setHeaderValue("Bearer " + this.token, "Authorization");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, json:any){
            completion(code, json != null ? json["data"] : []);
        });
    }  

    changeUserPassword(current:string, newPass:string, newPassConfirmation:string, completion:any) {
        const url = MIOURL.urlWithString(this.authURL + "/user/change-password");
        const body = {
            "CurrentPassword": current,
            "NewPassword": newPass,
            "NewPasswordConfirmation": newPassConfirmation
        }
        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        urlRequest.setHeaderValue("Bearer " + this.token, "Authorization");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, json:any){
            completion(code, json != null ? json["data"] : []);
        });
    }

    changeUserPasswordWithToken(token:string, newPass:string, newPassConfirmation:string, completion:any) {
        const url = MIOURL.urlWithString(this.authURL + "/user/reset-password-link");
        const body = {
            "Token": token,
            "NewPassword": newPass,
            "NewPasswordConfirmation": newPassConfirmation
        }
        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, body, "POST");
        // urlRequest.setHeaderValue("Bearer " + this.token, "Authorization");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, value:any){
            if (code == 200) {
                completion(value != null ? value["data"] : [], null);
            }
            else {
                completion(null, new Error(value));
            }
        });
    }

    activateUserWithToken(token:string, completion:any) {
        const url = MIOURL.urlWithString(this.authURL + "/user/activate?token=" + token);
        let urlRequest = new MWSJSONRequest();
        urlRequest.initWithURL(url, null, "GET");
        // urlRequest.setHeaderValue("Bearer " + this.token, "Authorization");
        urlRequest.setHeaderValue(this.enviroment, "DL-ENVIRONMENT");
        urlRequest.execute(this, function(code:number, value:any){
            if (code == 200) {
                completion(value != null ? value["data"] : {}, null);
            }
            else {
                completion(null, new Error(value));
            }
        });
    }

}